import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import CardGiftcardOutlinedIcon from "@material-ui/icons/CardGiftcardOutlined";
import InputAdornment from "@material-ui/core/InputAdornment";
import LinkIcon from "@material-ui/icons/Link";
import instance from "../../../store/actions/instance";
import QRCode from "qrcode.react";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxIcon from "@material-ui/icons/CheckBoxOutlined";
import MuiPhoneNumber from "material-ui-phone-number";
import Collapsible from "react-collapsible";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

class GiftForm extends Component {
  state = {
    name: this.props.name,
    message: this.props.message,
    gift_recipient_number: this.props.gift_recipient_number,
    gift_link: this.props.gift_link || "",
    showThumbnail: true,
    open: true,
  };

  getThumbnail = () => {
    if (!this.state.gift_link || !this.state.gift_link?.length) return null;
    if (
      !this.state.gift_link.includes("youtu") ||
      !this.state.gift_link.includes("http")
    )
      return null;
    if (this.state.gift_link.includes("youtu.be")) {
      const temp = this.state.gift_link.split("/");
      if (temp?.length > 1) return temp[temp.length - 1];
    } else {
      const temp = this.state.gift_link.split("=");
      if (temp?.length > 1) return temp[1];
    }
    return null;
  };

  render() {
    const { themeColor, language, settings, countries, address, store } =
      this.props;
    const countryObj = countries?.find((c) => c?.id === address?.country);
    const customTexts = this.props.settings.custom_texts;

    const InputLabelProps = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 5 : "unset",
      left: language == "english" ? 5 : "unset",
    };

    const currency =
      language == "english"
        ? settings.currency_english
        : settings.currency_local;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <>
        <div
          className={`w-100 ${settings?.enable_gift_form_open ? "py-2" : ""}`}
        >
          <Collapsible
            open={this.state.open}
            handleTriggerClick={(e) => {
              this.setState({ open: !this.state.open });
            }}
            trigger={
              <p
                style={{
                  direction: language === "arabic" && "rtl",
                  display: "flex",
                  alignItems: "center",
                  transition: "0.4s linear",
                  justifyContent: "space-between",
                }}
              >
                {!this.props.settings.enable_gift_form_open && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: 25,
                      direction: language === "arabic" ? "rtl" : "ltr",
                    }}
                    className="box-title"
                  >
                    <CardGiftcardOutlinedIcon style={{ color: "#5b5b5b" }} />{" "}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginLeft: language === "english" && "5px",
                        marginRight: language === "arabic" && "5px",
                        paddingBottom: "3px",
                      }}
                    >
                      <span
                        className={"mx-auto ".concat(
                          language === "english" ? "text-left" : "text-right"
                        )}
                        style={{
                          width: "100%",
                          textAlign: language === "english" ? "left" : "right",
                        }}
                      >
                        {language === "english"
                          ? "Gift Details"
                          : "تفاصيل الهدية"}
                      </span>
                      <span style={{ marginTop: "4px" }}>
                        <ArrowDropDownIcon
                          style={{
                            marginLeft: language === "english" && "auto",
                            marginRight: language === "arabic" && "auto",
                          }}
                        />
                      </span>
                    </div>
                  </div>
                )}
              </p>
            }
          >
            {
              <form
                onSubmit={(e) => e.preventDefault()}
                className="bordered px-4"
                style={{ backgroundColor: "white" }}
              >
                <TextField
                  label={
                    language == "english" ? "Receiver Name" : "الاسم المستلم"
                  }
                  fullWidth
                  error={this.props.errorName}
                  helperText={
                    this.props.errorName
                      ? language === "english"
                        ? "Please enter a name"
                        : "الرجاء إدخال اسم"
                      : ""
                  }
                  required={settings.enable_force_gift_name_number}
                  InputLabelProps={{
                    style: InputLabelProps,
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                  color="primary"
                  className="mt-3"
                  onChange={(e) => {
                    this.setState({ name: e.target.value });
                    this.props.handleChange(e);
                  }}
                  onBlur={(e) => {
                    this.setState({ name: e.target.value });
                    this.props.handleChange(e);
                  }}
                  name="name"
                  value={this.state.name}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />

                <MuiPhoneNumber
                  defaultCountry={
                    countryObj?.dial_code || store.default_dial_code || "kw"
                  }
                  onlyCountries={
                    settings.show_all_country_codes
                      ? []
                      : [
                          "kw",
                          "sa",
                          "qa",
                          "om",
                          "ae",
                          "bh",
                          "sy",
                          "lb",
                          "jo",
                          "eg",
                          "us",
                          "uk",
                          "cn",
                        ]
                  }
                  excludeCountries={["il"]}
                  countryCodeEditable={false}
                  disableAreaCodes={true}
                  error={this.props.errorNumber}
                  label={
                    language == "english"
                      ? "Receiver Phone"
                      : "رقم هاتف الشخص المستلم"
                  }
                  className="mt-4 mb-3"
                  onChange={this.props.handleChange}
                  fullWidth
                  helperText={
                    this.props.errorNumber
                      ? language === "english"
                        ? "Please enter a number"
                        : "الرجاء إدخال رقم"
                      : ""
                  }
                  required={settings.enable_force_gift_name_number}
                  InputLabelProps={{
                    style: InputLabelProps,
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                  color="primary"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  name="gift_recipient_number"
                  value={this.state.gift_recipient_number}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    marginTop: 10,
                    alignItems: "center",
                    flexDirection:
                      language === "arabic" ? "row-reverse" : "row",
                    right: language == "arabic" ? 5 : "unset",
                    left: language == "english" ? 5 : "unset",
                    position: "relative",
                  }}
                >
                  <span>
                    {language === "english"
                      ? "Call recipient on arrival"
                      : "اتصل على المستلم عند الوصول"}
                  </span>
                  <Checkbox
                    inputProps={{ "aria-label": "primary checkbox" }}
                    checkedIcon={<CheckBoxIcon style={{ color: themeColor }} />}
                    checked={this.props.call_recipient_check}
                    onChange={this.props.toggleCallRecipient}
                  />
                </div>

                {settings.enable_gifts_message_form && (
                  <div className="mb-5">
                    <TextField
                      label={language == "english" ? "Gift Message" : "الرسالة"}
                      multiline
                      fullWidth
                      rowsMax="8"
                      InputLabelProps={{
                        style: InputLabelProps,
                        dir: language == "english" ? "ltr" : "rtl",
                      }}
                      InputProps={{
                        dir: language == "english" ? "ltr" : "rtl",
                      }}
                      color="primary"
                      onChange={(e) => {
                        if (
                          e.target.value?.length <=
                            settings.gift_message_character_limit ||
                          settings.gift_message_character_limit === 0
                        ) {
                          this.setState({ message: e.target.value });
                          this.props.handleChange(e);
                        } else {
                        }
                      }}
                      onBlur={(e) => {
                        if (
                          e.target.value?.length <=
                            settings.gift_message_character_limit ||
                          settings.gift_message_character_limit === 0
                        ) {
                          this.setState({ message: e.target.value });
                          this.props.handleChange(e);
                        } else {
                        }
                      }}
                      inputProps={{
                        maxLength:
                          settings.gift_message_character_limit || 9999999999,
                      }}
                      name="message"
                      value={this.state.message}
                      FormHelperTextProps={{
                        style: {
                          textAlign: language == "arabic" && "right",
                          marginRight: language == "arabic" && 5,
                        },
                      }}
                    />
                    {!!settings.gift_message_character_limit && (
                      <span
                        style={{
                          float: language === "arabic" ? "left" : "right",
                          position: "relative",
                          top: -15,
                          color:
                            this.state.message?.length >=
                            settings.gift_message_character_limit
                              ? "#ff1b1b"
                              : "#616161",
                        }}
                      >
                        {language === "arabic" ? (
                          <>
                            {settings.gift_message_character_limit}/
                            {this.state.message?.length || 0}
                          </>
                        ) : (
                          <>
                            {this.state.message?.length || 0}/
                            {settings.gift_message_character_limit}
                          </>
                        )}
                      </span>
                    )}
                  </div>
                )}
                {settings.enable_send_gift_anonymously &&
                  settings.enable_send_gift_anonymously_staff && (
                    <div
                      style={{
                        display: "flex",
                        marginBottom: 10,
                        marginTop: 10,
                        alignItems: "center",
                        direction: "ltr",
                        flexDirection:
                          language === "arabic" ? "row-reverse" : "row",
                        right: language == "arabic" ? 5 : "unset",
                        left: language == "english" ? 5 : "unset",
                        position: "relative",
                      }}
                    >
                      <span>
                        {language === "english"
                          ? "Send gift anonymously"
                          : "إرسال الهدية بشكل مجهول"}
                      </span>
                      <Checkbox
                        inputProps={{ "aria-label": "primary checkbox" }}
                        checkedIcon={
                          <CheckBoxIcon style={{ color: themeColor }} />
                        }
                        checked={this.props.giftAnonymousCheck}
                        onChange={this.props.toggleGiftAnonymous}
                      />
                    </div>
                  )}
                {settings.enable_gift_wrapping && (
                  <div
                    style={{
                      display: "flex",
                      marginBottom: 10,
                      marginTop: 10,
                      alignItems: "center",
                      direction: "ltr",
                      flexDirection:
                        language === "arabic" ? "row-reverse" : "row",
                      right: language == "arabic" ? 5 : "unset",
                      left: language == "english" ? 5 : "unset",
                      position: "relative",
                    }}
                  >
                    <span>
                      {language === "english"
                        ? "Would you like to add gift wrapping?"
                        : "هل ترغب في إضافة تغليف الهدايا؟"}
                      ({" "}
                      <span
                        className={
                          currencyIcon
                        }
                      >
                        {`${parseFloat(settings.gift_wrapping_price).toFixed(
                          settings.currency_decimals
                        )} ${currency}`}
                      </span>
                      )
                    </span>
                    <Checkbox
                      inputProps={{ "aria-label": "primary checkbox" }}
                      checkedIcon={
                        <CheckBoxIcon style={{ color: themeColor }} />
                      }
                      checked={this.props.gift_wrapping}
                      onChange={this.props.toggleGiftWrapping}
                    />
                  </div>
                )}
                {settings.enable_gift_links && (
                  <>
                    <TextField
                      label={
                        language == "english"
                          ? "Share your feelings with a video"
                          : "عبر عن مشاعرك بفيديو"
                      }
                      placeholder={
                        language === "arabic"
                          ? "انسخ والصق رابط يوتيوب هنا"
                          : "Copy and paste a YouTube link here"
                      }
                      multiline
                      fullWidth
                      rowsMax="8"
                      InputLabelProps={{
                        style: { ...InputLabelProps, whiteSpace: "nowrap" },
                        dir: language == "english" ? "ltr" : "rtl",
                      }}
                      color="primary"
                      className={
                        settings.enable_gifts_message_form ? "mb-4" : "my-4"
                      }
                      onChange={(e) => {
                        this.setState({ gift_link: e.target.value });
                        this.props.handleChange(e);
                      }}
                      onBlur={(e) => {
                        this.setState({ gift_link: e.target.value });
                        this.props.handleChange(e);
                      }}
                      InputProps={{
                        dir: language == "english" ? "ltr" : "rtl",
                        startAdornment: (
                          <InputAdornment position="start">
                            <LinkIcon style={{ color: "#6c757d" }} />
                          </InputAdornment>
                        ),
                      }}
                      name="gift_link"
                      value={this.state.gift_link}
                      FormHelperTextProps={{
                        style: {
                          textAlign: language == "arabic" && "right",
                          marginRight: language == "arabic" && 5,
                        },
                      }}
                    />

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "auto auto",
                        marginBottom: "20px",
                      }}
                    >
                      <div>
                        <p
                          style={{
                            fontWeight: "bold",
                            marginBottom: 3,
                            color: "#6c757d",
                          }}
                        >
                          {language === "arabic"
                            ? "معاينة الرمز"
                            : "QR preview"}
                        </p>
                        <QRCode
                          value={
                            this.state.gift_link ||
                            "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
                          }
                          size={80}
                          id={"QR"}
                          style={{ opacity: !!this.state.gift_link ? 1 : 0.3 }}
                        />
                      </div>
                      <div>
                        <p
                          style={{
                            fontWeight: "bold",
                            marginBottom: 3,
                            color: "#6c757d",
                          }}
                        >
                          {language === "arabic"
                            ? "معاينة الفيديو"
                            : "Video preview"}
                        </p>
                        <img
                          src={`https://i.ytimg.com/vi/${
                            this.getThumbnail() || "a"
                          }/sddefault.jpg`}
                          style={{
                            width: 100,
                            height: 80,
                            opacity: !!this.state.gift_link ? 1 : 0.3,
                          }}
                          onError={() =>
                            this.setState({ showThumbnail: false })
                          }
                        />
                      </div>
                    </div>
                  </>
                )}
              </form>
            }
          </Collapsible>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    themeColor: state.store.store.settings.dark || "#0099cc",
    countries: state.store.store.all_countries || state.store.store.countries,
    address: state.customers.address,
    store: state.store.store,
  };
};
export default connect(mapStateToProps)(GiftForm);
